import React from 'react';

const ReportedItems = () => {
    return (
        <div>
            
        </div>
    );
};

export default ReportedItems;